/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2020. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Component, OnInit } from '@angular/core';
import { LoadingBarService } from '@shared/services';
import { delay, tap } from 'rxjs/operators';

@Component({
  selector: 'app-loading-bar',
  templateUrl: './loading-bar.component.html',
  styleUrls: ['./loading-bar.component.scss'],
})
export class LoadingBarComponent implements OnInit {
  showBar: boolean;

  constructor(private loadingBarService: LoadingBarService) {}

  ngOnInit() {
    this.loadingBarService
      .getShowStateSubject()
      .pipe(
        delay(0),
        tap((show) => (this.showBar = show))
      )
      .subscribe();
  }
}
